import { observable, computed } from 'mobx'
import Model from '../shared/model'

import validate from '../shared/decorators/model/validate'

@validate({
  offeringId: 'number',
  offeringType: 'string',
  participate: 'boolean',
  acceptDataUsage: 'boolean',
  userFirstname: 'required|string|minLen:2',
  userLastname: 'required|string|minLen:2',
  userStreet: 'string',
  userZip: 'string',
  userLocation: 'string',
  school: 'string',
  overallImpression: 'number|min:1|max:5',
  didactically: 'number|min:1|max:5',
  presentation: 'number|min:1|max:5',
  spacial: 'number|min:1|max:5',
  win: 'number|min:1|max:5',
  recommendationRate: 'boolean',
  comment: 'string',
})
export default class Rating extends Model {

  @observable offeringId = null

  @observable offeringType = ''

  @observable museum = {}

  @observable museumCryptoId = ''

  @observable participate = false

  @observable acceptDataUsage = false

  @observable userFirstname = ''

  @observable userLastname = ''

  @observable userStreet = ''

  @observable userZip = ''

  @observable userLocation = ''

  @observable school = ''

  @observable overallImpression = 0

  @observable didactically = 0

  @observable presentation = 0

  @observable spacial = 0

  @observable win = 0

  @observable recommendationRate = false

  @observable wayOfDiscovery: {
    teacher: false,
    musbi: false,
    homepageMusem: false,
    flyerMusem: false,
    press: false,
    collegue: false
  }

  @computed get asJSON() {

    return {
      participate: this.participate,
      acceptDataUsage: this.acceptDataUsage,
      userFirstname: this.userFirstname,
      userLastname: this.userLastname,
      userStreet: this.userStreet,
      userZip: this.userZip,
      userLocation: this.userLocation,
      school: this.school,
      overallImpression: this.overallImpression,
      didactically: this.didactically,
      presentation: this.presentation,
      spacial: this.spacial,
      win: this.win,
      wayOfDiscovery: Object.keys(this.wayOfDiscovery || {}).filter((key) => {
        return !!this.wayOfDiscovery[key]
      }).join(','),
      recommendationRate: this.recommendationRate,
      comment: this.comment,
      offeringId: this.offeringId,
      offeringType: this.offeringType,
      museum: this.museum,
      museumCryptoId: this.museumCryptoId,
    }

  }

  getJSON() {
    return this.asJSON
  }

}



// WEBPACK FOOTER //
// ./src/rating/model.js